import { createApp, provide, h } from 'vue';
import App from './App.vue';
import router from './router';
import { DefaultApolloClient } from '@vue/apollo-composable';
import apolloClient from './composables/useApolloClient';
import clickOutside from './directives/v-click-outside.js';
import { auth0 } from './composables/useAuth0Client';
import useSecurityKey from './composables/useSecurityKey';

createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },

  render: () => h(App),
})
  .use(auth0)
  .use(router)
  .directive('click-outside', clickOutside)
  .mount('#app');
